module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-default margin-bottom-0px"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Campaign List")]), _vm._v(" "), _c('div', {
    staticClass: "action-button pull-right"
  }, [(!_vm.isDeletedSelected) ? _c('div', {
    staticClass: "form-group col-xs-12 col-sm-3"
  }, [_c('label', {
    attrs: {
      "for": "date-from"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('nv-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "id": "ddlSelect"
    },
    on: {
      "change": _vm.searchOpportunityWithSelectedCriteria
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- All --")]), _vm._v(" "), _vm._l((_vm.statusList), function(data) {
    return _c('option', {
      key: data.id,
      domProps: {
        "value": data.id,
        "selected": data === _vm.status
      }
    }, [_vm._v(_vm._s(data.status))])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-3",
    staticStyle: {
      "flex-wrap": "nowrap !important"
    }
  }, [_c('label', {
    attrs: {
      "for": "date-from"
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDt),
      expression: "fromDt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "date-from",
      "placeholder": "From"
    },
    domProps: {
      "value": (_vm.fromDt)
    },
    on: {
      "keyup": _vm.searchOpportunityWithSelectedCriteria,
      "change": _vm.searchOpportunityWithSelectedCriteria,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.clearDate('fromDt')
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-3"
  }, [_c('label', {
    attrs: {
      "for": "date-to"
    }
  }, [_vm._v("End Date")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDt),
      expression: "toDt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "date-to",
      "placeholder": "To"
    },
    domProps: {
      "value": (_vm.toDt)
    },
    on: {
      "keyup": _vm.searchOpportunityWithSelectedCriteria,
      "change": _vm.searchOpportunityWithSelectedCriteria,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.clearDate('toDt')
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6 search-opportunity"
  }, [_c('label', {
    attrs: {
      "for": "date-to"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "reset-input",
      rawName: "v-reset-input"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.searchOpportunity),
      expression: "searchOpportunity"
    }],
    staticClass: "search-box-reset form-control mrgn-right-20px searchBox",
    attrs: {
      "type": "text",
      "placeholder": "Type here to search and press 'Enter'"
    },
    domProps: {
      "value": (_vm.searchOpportunity)
    },
    on: {
      "keyup": _vm.searchOpportunityWithSelectedCriteria,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchOpportunity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6 create-opportunity"
  }, [_c('label', {
    attrs: {
      "for": "date-to"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/opportunity"
    }
  }, [_vm._v("Create Campaign")])], 1)])]), _vm._v(" "), (_vm.actionInProgress) ? _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/loader/nivi-loader.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#saved",
      "aria-controls": "saved",
      "role": "tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.tabChange('saved')
      }
    }
  }, [_vm._v("Saved Campaigns")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#deleted",
      "aria-controls": "deleted",
      "role": "tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.tabChange('Deleted')
      }
    }
  }, [_vm._v("Deleted Campaigns")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "saved"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-apps"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('th', {
    staticClass: "padding-left5px"
  }, [_vm._v("Campaign Name "), _c('i', {
    staticClass: "fa fa-long-arrow-up",
    on: {
      "click": function($event) {
        return _vm.sortOpportunity('opportunity_name', 'asc', 'saved')
      }
    }
  }), _c('i', {
    staticClass: "fa fa-long-arrow-down",
    on: {
      "click": function($event) {
        return _vm.sortOpportunity('opportunity_name', 'desc', 'saved')
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Customer Name "), _c('i', {
    staticClass: "fa fa-long-arrow-up",
    on: {
      "click": function($event) {
        return _vm.sortOpportunity('customer_name', 'asc', 'saved')
      }
    }
  }), _c('i', {
    staticClass: "fa fa-long-arrow-down",
    on: {
      "click": function($event) {
        return _vm.sortOpportunity('customer_name', 'desc', 'saved')
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "padding-left5px"
  }, [_vm._v("Country")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Created On")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Test Nudge")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Change To")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Clone/Copy")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Edit")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Delete")])]), _vm._v(" "), _c('tbody', [(_vm.opportunityList.length === 0 && !_vm.loading) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("No Result found.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.opportunityList), function(opportunity, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.opportunityList.length),
        expression: "opportunityList.length"
      }],
      key: index
    }, [_c('td', [_vm._v(_vm._s(opportunity.opportunity_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opportunity.customer_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opportunity.country_name))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [(opportunity.created) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(opportunity.created, 'd/M/Y hh:ss')))]) : _vm._e(), _vm._v(" "), (!opportunity.created) ? _c('span', [_vm._v("--")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [(opportunity.opportunity_status === 0) ? _c('span', [_vm._v("Draft")]) : _vm._e(), _vm._v(" "), (opportunity.opportunity_status === 1) ? _c('span', [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (opportunity.opportunity_status === 2) ? _c('span', [_vm._v("Expired")]) : _vm._e(), _vm._v(" "), (opportunity.opportunity_status === 3) ? _c('span', [_vm._v("Deleted")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [((!opportunity.is_in_session) && opportunity.group_list && opportunity.group_list.length) ? _c('input', {
      staticClass: "btn btn-primary btn-sm center",
      attrs: {
        "type": "button",
        "value": "Send Test"
      },
      on: {
        "click": function($event) {
          return _vm.testNudgeClick(opportunity)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, _vm._l((_vm.changeOpportunityStatusMap[opportunity.opportunity_status]), function(status) {
      return _c('span', {
        key: status,
        staticStyle: {
          "margin-right": "10px"
        }
      }, [_c('span', {
        class: status.class,
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            return _vm.showOpportunityStatusUpdatePopup(_vm.opportunityStatusMap[status.status], opportunity.opportunity_status, index)
          }
        }
      }, [_vm._v(_vm._s(status.status))])])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_c('router-link', {
      attrs: {
        "to": ("/opportunity/" + (opportunity.id) + "/copyOpportunity")
      }
    }, [_c('input', {
      staticClass: "btn btn-primary btn-sm center",
      attrs: {
        "type": "button",
        "value": "Copy Campaign"
      }
    })])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_c('router-link', {
      attrs: {
        "to": ("/opportunity/" + (opportunity.id))
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_c('i', {
      staticClass: "fa fa-times-circle link-action-color",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.showOpportunityDeleteConfirmationPopup(opportunity, index)
        }
      }
    })])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [(_vm.savedPageCount > 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.savedPageCount,
      "click-handler": _vm.getDataForSavedPage,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "deleted"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-apps"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('th', {
    staticClass: "padding-left5px"
  }, [_vm._v("Campaign Name "), _c('i', {
    staticClass: "fa fa-long-arrow-up",
    on: {
      "click": function($event) {
        return _vm.sortOpportunity('opportunity_name', 'asc', 'deleted')
      }
    }
  }), _c('i', {
    staticClass: "fa fa-long-arrow-down",
    on: {
      "click": function($event) {
        return _vm.sortOpportunity('opportunity_name', 'desc', 'deleted')
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "padding-left5px"
  }, [_vm._v("Customer Name "), _c('i', {
    staticClass: "fa fa-long-arrow-up",
    on: {
      "click": function($event) {
        return _vm.sortOpportunity('customer_name', 'asc', 'deleted')
      }
    }
  }), _c('i', {
    staticClass: "fa fa-long-arrow-down",
    on: {
      "click": function($event) {
        return _vm.sortOpportunity('customer_name', 'desc', 'deleted')
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "padding-left5px"
  }, [_vm._v("Country")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Created On")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Status")])]), _vm._v(" "), _c('tbody', [(_vm.deletedOpportunityList.length === 0 && !_vm.loading) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("No Result found.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.deletedOpportunityList), function(opportunity, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.deletedOpportunityList.length),
        expression: "deletedOpportunityList.length"
      }],
      key: index
    }, [_c('td', [_vm._v(_vm._s(opportunity.opportunity_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opportunity.customer_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opportunity.country_name))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [(opportunity.created) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(opportunity.created, 'd/M/Y hh:ss')))]) : _vm._e(), _vm._v(" "), (!opportunity.created) ? _c('span', [_vm._v("--")]) : _vm._e()]), _vm._v(" "), _vm._m(1, true)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [(_vm.deletedPageCount > 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.deletedPageCount,
      "click-handler": _vm.getDataForDeletedPage,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)])])])])])])]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendTestNudge.apply(null, arguments)
      }
    }
  }, [(_vm.audienceSelectionVisible) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "userSelection"
    }
  }, [_c('div', {
    staticClass: "modal modal-md modal-user-selection"
  }, [_c('div', {
    staticClass: "test-nudge-container"
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "form-horizontal"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
    }, [_c('label', {
      staticClass: "control-label modal-label",
      attrs: {
        "for": "search"
      }
    }, [_vm._v("Select Group:")]), _vm._v("\n                    \n                  "), _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-flow": "wrap"
      }
    }, _vm._l((_vm.selectedReengagement.group_list), function(group) {
      return _c('div', {
        key: group.group_name,
        staticStyle: {
          "width": "233px"
        }
      }, [_c('label', {
        staticClass: "radio-inline campaign-group-details",
        class: {
          'reengagement-group-disabled': !group.msg_template_id
        },
        staticStyle: {
          "display": "flex",
          "flex-direction": "column",
          "margin-bottom": "10px",
          "padding-left": "20px"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedGroup),
          expression: "selectedGroup"
        }],
        attrs: {
          "type": "radio",
          "disabled": !group.msg_template_id
        },
        domProps: {
          "value": group,
          "checked": _vm._q(_vm.selectedGroup, group)
        },
        on: {
          "change": function($event) {
            _vm.selectedGroup = group
          }
        }
      }), _vm._v(" "), _c('div', [_vm._v(_vm._s(group.group_name))]), _vm._v(" "), _c('div', [_vm._v("Nudge: "), _c('span', {
        staticClass: "campaign-details-text"
      }, [_vm._v(_vm._s(group.msg_template_name ? group.msg_template_name : '-'))])]), _vm._v(" "), _c('div', [_vm._v("Split Percent: "), _c('span', {
        staticClass: "campaign-details-text"
      }, [_vm._v(_vm._s(group.split_percent || group.split_percent === 0 ? group.split_percent + '%' : '-'))])])])])
    }), 0), _vm._v(" "), (_vm.submittedTestNudge && !_vm.$v.selectedGroup.required) ? _c('span', {
      staticClass: "text-red pull-right",
      staticStyle: {
        "margin-right": "20px"
      }
    }, [_vm._v("Please select a group.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
    }, [_c('label', {
      staticClass: "control-label modal-label",
      attrs: {
        "for": "search"
      }
    }, [_vm._v("Select test user(s):")]), _vm._v(" "), _c('label', {
      staticClass: "hint-text"
    }, [_vm._v("Only onboarded users appear here. To include your account in a test, make sure you're currently onboarded to the correct country.")]), _vm._v("\n                    \n                  "), _c('div', {
      staticClass: "users-checkbox-container"
    }, [_vm._l((_vm.userList), function(user) {
      return _c('div', {
        key: user.account_id
      }, [_c('label', {
        staticClass: "checkbox-inline col-xs-6 col-sm-6 col-md-5 col-lg-4"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedUsers),
          expression: "selectedUsers"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": user,
          "checked": Array.isArray(_vm.selectedUsers) ? _vm._i(_vm.selectedUsers, user) > -1 : (_vm.selectedUsers)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.selectedUsers,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = user,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.selectedUsers = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.selectedUsers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.selectedUsers = $$c
            }
          }
        }
      }), _vm._v(_vm._s(user.account_name) + "\n                      ")])])
    }), _vm._v(" "), (!_vm.userList.length) ? _c('div', [_vm._v("There are no users ")]) : _vm._e()], 2), _vm._v(" "), (_vm.submittedTestNudge && !_vm.$v.selectedUsers.required) ? _c('span', {
      staticClass: "text-red pull-right",
      staticStyle: {
        "margin-right": "20px"
      }
    }, [_vm._v("Please select users to send message.")]) : _vm._e()])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeAudienceSelection
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send Test")])])])])])]) : _vm._e()]), _vm._v(" "), (_vm.isOppStatusChangeConfirmationVisible) ? _c('opportunityStatusChangeModal', {
    attrs: {
      "isOppStatusChangeConfirmationVisible": _vm.isOppStatusChangeConfirmationVisible,
      "confirmationMessage": _vm.confirmationMessage,
      "actionToBePerformed": _vm.actionToBePerformed
    },
    on: {
      "close": _vm.closeConfirmationModal,
      "deleteOpportunity": _vm.deleteOpportunity,
      "updateOpportunityStatus": _vm.updateOpportunityStatus
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOppReportModalVisible) ? _c('opportunityReportModal', {
    attrs: {
      "opportunityReport": _vm.opportunityReport,
      "isOppReportModalVisible": _vm.isOppReportModalVisible,
      "modalTitle": _vm.modalTitle
    },
    on: {
      "close": _vm.closeReport
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOppStatusAlertModalVisible) ? _c('opportunityStatusAlertModal', {
    attrs: {
      "alertTitle": _vm.alertTitle,
      "warningMessage": _vm.warningMessage,
      "opportunityStatus": _vm.opportunityStatus,
      "isOppStatusAlertModalVisible": _vm.isOppStatusAlertModalVisible
    },
    on: {
      "close": _vm.closeAlert
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Database Marketing Campaigns\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v("Campaigns")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Campaign List")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "align-center"
  }, [_c('span', [_vm._v("Deleted")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-43abc7f7","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/opportunity-management/opportunityList.vue
// module id = KnwG
// module chunks = 1